// 表格插入行/列的方向
export enum InsertDirection {
    ABOVE, // 上方插入行
    BELOW, // 下方插入行
    LEFT, // 左侧插入列
    RIGHT, // 右侧插入列
}
// 表格删除行/列
export enum DeleteDirection {
    ROW,
    COLUMN,
}

// 修改行高/列宽/全部修改
export enum ModifyDirection {
    ALL,
    HEIGHT,
    WIDTH,
}

// table 内部操作类型
export enum TableChangeType {
    Update = 'update',
    Add = 'add',
    Remove = 'remove',
}

// table 属性更新的具体类型
export enum TableCellUpdateType {
    Text = 'text',
    CellProperties = 'cellProperties',
}
